/**
 * Testimonials JS
 *
 * @since   1.0.0
 * @package lighting-pros
 */

(function($) {
	$(document).ready(function() {

		// testimonials slider layout
		if ($('.testimonials-slider').length) {

			$('.testimonials-slider').flickity({
				cellAlign: 'left',
				prevNextButtons: false,
				initialIndex: 0,
			});

		}

	}); // document.ready
})(jQuery);
